/* 商品优惠券：复制商品元字段中配置的券码。 */
(function () {
  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy') ? resolve() : reject(new Error('Copy command failed'));
      } catch (error) {
        reject(error);
      } finally {
        textarea.remove();
      }
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mm-promotion-coupon-copy]');
    if (!button) return;

    var root = button.closest('[data-mm-promotion-coupon]');
    var code = root && root.getAttribute('data-coupon-code');
    if (!code) return;

    var label = button.querySelector('[data-mm-promotion-coupon-label]');
    var status = root.querySelector('[data-mm-promotion-coupon-status]');
    var originalLabel = label ? label.textContent : 'Copy Code';

    copyText(code).then(function () {
      if (label) label.textContent = 'Copied!';
      if (status) status.textContent = 'Coupon code copied.';
      window.setTimeout(function () {
        if (label) label.textContent = originalLabel;
      }, 1800);
    }).catch(function () {
      if (status) status.textContent = 'Unable to copy the coupon code.';
    });
  });
})();
